import { of } from 'rxjs';
import { IRunbookService } from '@nimbus-library/features/feature-permission/services/contracts/i-runbook.service';

export class DefaultRunbookService extends IRunbookService {
  public isRunbookEnabled(tenantId: string) {
    return of(false);
  }
}
